// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3Egr2","content":"LayoutSettings_content__1xfr0"};